import React, { useMemo } from 'react';

import classnames from 'classnames';

import Typography from 'components/uiLibrary/Typography';

import classes from './TabSwitch.module.scss';

const TabSwitch = ({ options = [], value, onChange }) => {
  const { tabStyles, parentStyles } = useMemo(() => {
    if (!options.length) {
      return {};
    }

    return {
      tabStyles: {
        width: `calc(100% / ${options.length})`,
      },
      parentStyles: {
        maxWidth: `calc(220px * ${options.length})`,
      },
    };
  }, [options]);

  if (!options.length) {
    return null;
  }

  return (
    <div className={classes.root} style={parentStyles}>
      {options.map(option => {
        const isSelected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            className={classnames(classes.tab, {
              [classes.selected]: isSelected,
            })}
            style={tabStyles}
            onClick={e => onChange && onChange(e, option)}
          >
            <Typography 
              color={isSelected ? 'link' : 'primary'} 
              size={13} 
              weight="medium"
              truncate
            >
              {option.label}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};

export default TabSwitch;
